import * as moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')
window.moment = moment
